// operating_hours JSON stored in new_charging_station_details.
// The backend default (cms_handler.go parseJSONRawMessage) is {"default":"24x7"};
// custom hours keep that key and add a per-day schedule:
//   {"default":"custom","schedule":{"monday":{"open":"06:00","close":"22:00","closed":false}, ...}}

export const DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export const ALWAYS_OPEN = { default: "24x7" };

export const defaultSchedule = () =>
  Object.fromEntries(DAYS.map((d) => [d, { open: "06:00", close: "22:00", closed: false }]));

export function parseOperatingHours(value) {
  let v = value;
  if (typeof v === "string") {
    try {
      v = JSON.parse(v);
    } catch {
      v = null;
    }
  }
  if (v && v.default === "custom" && v.schedule && typeof v.schedule === "object") {
    const base = defaultSchedule();
    for (const d of DAYS) if (v.schedule[d]) base[d] = { ...base[d], ...v.schedule[d] };
    return { mode: "custom", schedule: base };
  }
  return { mode: "24x7", schedule: defaultSchedule() };
}

export function buildOperatingHours(mode, schedule) {
  return mode === "custom" ? { default: "custom", schedule } : ALWAYS_OPEN;
}

export function validateSchedule(schedule) {
  for (const d of DAYS) {
    const s = schedule[d];
    if (s.closed) continue;
    if (!s.open || !s.close) return `Set opening and closing time for ${d}`;
    if (s.open === s.close) return `Opening and closing time are the same on ${d}`;
  }
  if (DAYS.every((d) => schedule[d].closed)) return "At least one day must be open";
  return "";
}

export function describeOperatingHours(value) {
  const { mode, schedule } = parseOperatingHours(value);
  if (mode === "24x7") return "24x7";
  const open = DAYS.filter((d) => !schedule[d].closed);
  const first = schedule[open[0]];
  const uniform = open.every((d) => schedule[d].open === first.open && schedule[d].close === first.close);
  if (uniform) return `${first.open}–${first.close} · ${open.length === 7 ? "daily" : `${open.length} days`}`;
  return "Custom schedule";
}
